// Constants use for the path param of files queries
export const FILE_TYPES = {
    CHARACTER: 'character',
    MAP: 'map',
    CAMPAIGN: 'character',
};
